module.exports = __webpack_public_path__ + "static/media/help-icon.d4bc8f70.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/megabus/help-icon.svg
// module id = 236
// module chunks = 0